import { useTranslation } from 'react-i18next'

import { useDateLimits } from '../../../../../../hooks'
import Button, {
  BUTTON_HEIGHT_24,
  BUTTON_HEIGHT_32,
} from '../../../../../Button'
import { DatePicker } from '../../../../../DateTime'
import { ICON_HEIGHT_16 } from '../../../../../Icon'
import { IntegerInput } from '../../../../../Input'

import {
  QA_NAME_MATCH_EDITOR_CANCEL,
  QA_NAME_MATCH_EDITOR_INPUT,
  QA_NAME_MATCH_EDITOR_SAVE,
} from './ApplicantFitCheckBlockRowEditor.constants'
import {
  getIsMatchEditorDateKind,
  getMatchEditorLimits,
} from './ApplicantFitCheckBlockRowEditor.utils'

import * as styles from './ApplicantFitCheckBlockRowEditor.module.css'

import CheckmarkIcon from '../../../../../../icons/checkmark.svg'
import CloseIcon from '../../../../../../icons/close.svg'

function ApplicantFitCheckBlockRowEditor({
  criterion,
  isSaving,
  value,
  onCancel,
  onChange,
  onSave,
}) {
  const { t } = useTranslation()

  const { maxDate, minDate } = useDateLimits()

  const { max, min } = getMatchEditorLimits(criterion)

  return (
    <div className={styles.ApplicantFitCheckBlockRowEditor}>
      {getIsMatchEditorDateKind(criterion) ? (
        <DatePicker
          autoFocus
          disabled={isSaving}
          height={BUTTON_HEIGHT_32}
          maxValue={maxDate}
          minValue={minDate}
          qaName={QA_NAME_MATCH_EDITOR_INPUT}
          value={value}
          wrapperClassName={styles.input}
          onChange={onChange}
        />
      ) : (
        <IntegerInput
          autoFocus
          disabled={isSaving}
          height={BUTTON_HEIGHT_32}
          max={max}
          min={min}
          qaName={QA_NAME_MATCH_EDITOR_INPUT}
          value={value}
          wrapperClassName={styles.input}
          onChange={onChange}
        />
      )}
      <span className={styles.actions}>
        <Button.Text
          isGrey
          beforeIconProps={{ Icon: CheckmarkIcon, height: ICON_HEIGHT_16 }}
          disabled={isSaving}
          height={BUTTON_HEIGHT_24}
          qaName={QA_NAME_MATCH_EDITOR_SAVE}
          tooltip={t('RentalPortal.MatchEditorSaveKey')}
          onClick={onSave}
        />
        <Button.Text
          isGrey
          beforeIconProps={{ Icon: CloseIcon, height: ICON_HEIGHT_16 }}
          disabled={isSaving}
          height={BUTTON_HEIGHT_24}
          qaName={QA_NAME_MATCH_EDITOR_CANCEL}
          tooltip={t('RentalPortal.MatchEditorCancelKey')}
          onClick={onCancel}
        />
      </span>
    </div>
  )
}

export default ApplicantFitCheckBlockRowEditor
